import * as React from "react";

import styles from "./TypesOfCareFilters.module.scss";

type filterObject = {
	earlyEducationFilters: earlyEducationFilterObject,
	outOfHoursFilters: outOfHoursFilterObject,
}

type earlyEducationFilterObject = {
	'child-care-centre': boolean,
	'family-day-care': boolean,
	'pre-school': boolean,
	all: boolean,
}

type outOfHoursFilterObject = {
	'before-school-care': boolean,
	'after-school-care': boolean,
	'occasional-care': boolean,
	'vacation-care': boolean,
	all: boolean,
}

type Props = {
	closeModal: () => void,
	show: boolean,
	updateFilters: (filters: filterObject) => void,
	updateCount: (count: number) => void,
	count: number,
	filters: filterObject,
	doSearch: () => void,
	clearFilters: (search: boolean) => void,
	locationModel: any
};

declare var c4kCore: any;

const activeFilterButton: string = "button cta-filter";
const inactiveFilterButton: string = "button cta-tertiary text-base font-normal border-skin-neutral-light";

export const TypesOfCareFilters = (props: Props) => {
	let eventSuburb = `${props.locationModel.suburbName}, ${props.locationModel.stateAbbreviation}, ${props.locationModel.postcode}`;
	let eventLabel = `type=filter_type|source=Srp`;
	// Handle clicking on a filter item
	const SelectFilter = (group: string, item: string) => {
		let cloneFilters: filterObject = props.filters;

		 // if 'All'
		if (item == 'all') {
			if (!cloneFilters[group].all) {
				Object.entries(cloneFilters[group]).forEach(([key, value]) => {
					if (!value) {
						cloneFilters[group][key] = true;
					}
				});
			} else {
				Object.entries(cloneFilters[group]).forEach(([key, value]) => cloneFilters[group][key] = false);
			}
			// Else
		} else {
			cloneFilters[group][item] = !cloneFilters[group][item];

			if (!cloneFilters[group][item]) {
				cloneFilters[group].all = false;
			}
			if (cloneFilters[group][item]) {
				let falseItems = Object.entries(cloneFilters[group]).filter(([key, value]) => value == false);
				if (falseItems.length == 1 && !cloneFilters[group].all) {
					cloneFilters[group].all = true;
				}
			}
		}

		// Count the number of filters that are on
		let newCount: number = Object.entries(cloneFilters.earlyEducationFilters).filter(([key, value]) => (value == true && key != "all")).length;
		newCount += Object.entries(cloneFilters.outOfHoursFilters).filter(([key, value]) => (value == true && key != "all")).length;

		props.updateFilters(cloneFilters);
		props.updateCount(newCount);
	}

	// Handle Clicking the overlay outside the modal box
	const OverlayClick = (e) => {
		if (e.target.id == 'toc-filters-modal') {

			HandleClose();
		}
	}		

	const ClearFilters = () => {
		//let cloneFilters: filterObject = props.filters;
		//Object.entries(cloneFilters.earlyEducationFilters).forEach(([key, value]) => cloneFilters.earlyEducationFilters[key] = false);
		//Object.entries(cloneFilters.outOfHoursFilters).forEach(([key, value]) => cloneFilters.outOfHoursFilters[key] = false);

		//let newCount: number = Object.entries(cloneFilters.earlyEducationFilters).filter(([key, value]) => (value == true && key != "all")).length;
		//newCount += Object.entries(cloneFilters.outOfHoursFilters).filter(([key, value]) => (value == true && key != "all")).length;

		//props.updateFilters(cloneFilters);
		//props.updateCount(newCount);
		props.clearFilters(true)
		props.closeModal()
		c4kCore.analyticsTrackEvent("Search Results", "Types of Care Filter", eventLabel, eventSuburb); //Clear
	}
	 
	const ListenForEscKey = React.useCallback((e) => {
		if (e.keyCode === 27) {
			HandleClose();
		}
	}, []);

	const HandleClose = () => {
		props.closeModal();
		c4kCore.analyticsTrackEvent("Search Results", "Types of Care Filter", eventLabel, eventSuburb); //Close
		
		
	}

	React.useEffect(() => {
		document.addEventListener("keydown", ListenForEscKey, false);

		return () => {
			document.removeEventListener("keydown", ListenForEscKey, false);
		};
	}, []);

	const doSearch = () => {
		props.doSearch()
		props.closeModal()
		c4kCore.analyticsTrackEvent("Search Results", "Types of Care Filter", eventLabel, eventSuburb); //Apply
	}


	React.useEffect(() => {
		if (typeof window !== "undefined") {
			const adjustHeight = () => {
				const footerTabs = document.getElementById('footer-tabs');
				const wrapperTypesOfCare = document.getElementById("wrapper-types-of-care");
				const buttonGroup = document.getElementById('button-group');
				if (!footerTabs) {
					wrapperTypesOfCare.style.height = "100%";
					return;
				} 
				if (window.getComputedStyle(footerTabs).display === 'none') {
					wrapperTypesOfCare.style.height = "100%";
				}
				else {
					document.getElementById('type-filters-scroll-area').style.paddingBottom = '79px'
					buttonGroup.style.bottom = '63px';
					wrapperTypesOfCare.style.height = "100%";
					//wrapperTypesOfCare.style.height = "calc(100vh - 132px)";
				}
			}
			adjustHeight();


			window.addEventListener('resize', adjustHeight)

			return () => {
				window.removeEventListener('resize', adjustHeight);
			};
		}

	}, [])



	return (
		<React.Fragment>

			<div
				id="toc-filters-modal"
				className={`bg-skin-modal-overlay fixed inset-0 flex items-center justify-center z-102 ${props.show ? "" : "hidden"}`}
				aria-modal="true"
				aria-labelledby="modal-title"
				role="dialog"
				onClick={() => OverlayClick(event)}
			>
				<div className="bg-skin-modal-box md:rounded-3xl z-70 mx-auto w-full md:w-9/12 lg:w-1/2 h-full md:max-h-80pc overflow-y-auto relative">
					{/*<div className="absolute right-8 top-8 flex flex-row items-center justify-center rounded-full bg-white p-2 z-103">*/}
					
					{/*	<button onClick={HandleClose}>*/}
					{/*		<img className="modal-close" src="/img/icons/close-icon.svg" alt="Close icon" />*/}
					{/*	</button>*/}
					{/*</div>*/}

					{/*Modal Body*/}
					<div className="relative" id="wrapper-types-of-care">
						<div className="flex flex-col justify-between h-full relative bg-skin-filter-modal">
							<div className="pt-8 px-4 lg:px-8 overflow-y-auto" id="type-filters-scroll-area">
								<div className="text-base font-semibold mb-12 lg:text-3xl lg:font-normal pt-10 lg:pt-0 md:pt-0 flex items-center justify-between">
									Types of care - {props.count}
									<div className="flex flex-row items-center justify-center rounded-full bg-white p-2 z-103">
										<button onClick={HandleClose}>
											<img className="modal-close" src="/img/icons/close-icon.svg" alt="Close icon" />
										</button>
									</div>
								</div>
								

								{/*<div className="text-base font-semibold mb-12 lg:text-3xl lg:font-normal pt-1 lg:pt-0">*/}
								{/*	Types of care - {props.count}*/}
								{/*</div>*/}
								{/*<div className="absolute right-8 top-8 flex flex-row items-center justify-center rounded-full bg-white p-2 z-103">*/}
								{/*	<button onClick={HandleClose}>*/}
								{/*		<img className="modal-close" src="/img/icons/close-icon.svg" alt="Close icon" />*/}
								{/*	</button>*/}
								{/*</div>*/}



								{/*<!--Early Education options-->*/}
								<div className="mb-3.5 text-base font-bold">
									Early Education Child Care
								</div>
								<div className="flex flex-wrap items-center gap-3 mb-8">
									<button
										onClick={() => SelectFilter("earlyEducationFilters", "child-care-centre")}
										className={props.filters.earlyEducationFilters["child-care-centre"] ? activeFilterButton : inactiveFilterButton}>
										Childcare centres
									</button>
									<button
										onClick={() => SelectFilter("earlyEducationFilters", "family-day-care")}
										className={props.filters.earlyEducationFilters["family-day-care"] ? activeFilterButton : inactiveFilterButton}>
										Family day care
									</button>
									<button
										onClick={() => SelectFilter("earlyEducationFilters", "pre-school")}
										className={props.filters.earlyEducationFilters["pre-school"] ? activeFilterButton : inactiveFilterButton}>
										Preschool / Kindergarten
									</button>
									<button
										onClick={() => SelectFilter("earlyEducationFilters", "all")}
										className={props.filters.earlyEducationFilters.all ? activeFilterButton : inactiveFilterButton}>
										All
									</button>
								</div>

								{/*<!--Out of hours options-->*/}
								<div className="mb-3.5 text-base font-bold">
									Out of Hours School Care
								</div>
								<div className="flex flex-wrap items-center gap-3 mb-8">
									<button
										onClick={() => SelectFilter("outOfHoursFilters", "before-school-care")}
										className={props.filters.outOfHoursFilters["before-school-care"] ? activeFilterButton : inactiveFilterButton}>
										Before school care
									</button>
									<button
										onClick={() => SelectFilter("outOfHoursFilters", "after-school-care")}
										className={props.filters.outOfHoursFilters["after-school-care"] ? activeFilterButton : inactiveFilterButton}>
										After school care
									</button>
									<button
										onClick={() => SelectFilter("outOfHoursFilters", "occasional-care")}
										className={props.filters.outOfHoursFilters["occasional-care"] ? activeFilterButton : inactiveFilterButton}>
										Occasional casual or flexible care
									</button>
									<button
										onClick={() => SelectFilter("outOfHoursFilters", "vacation-care")}
										className={props.filters.outOfHoursFilters["vacation-care"] ? activeFilterButton : inactiveFilterButton}>
										Vacation care
									</button>
									<button
										onClick={() => SelectFilter("outOfHoursFilters", "all")}
										className={props.filters.outOfHoursFilters.all ? activeFilterButton : inactiveFilterButton}>
										All
									</button>
								</div>
								
							</div>
							<div className={"sticky md:bottom-0 flex flex-row items-center justify-between p-4 lg:px-8 w-full bg-white"} id="button-group">
								<button
									onClick={() => doSearch()}
									className="button cta-primary"
								>
									<span className="items-center gap-1.5" x-bind:class="$store.search.loading == true ? 'flex' : 'hidden'">
										<img src="/img/white-spinner.svg" alt="Spinner white dots circle" /><span>searching...</span>
									</span>
									<span x-bind:class="$store.search.loading == false ? '' : 'hidden'">
										Apply filters
									</span>
								</button>
								<button
									onClick={() => ClearFilters()}
									disabled={props.count == 0}
									className={`button ${props.count == 0 ? "text-gray-300" : "text-black"}`}
								>
									Clear all
								</button>
							</div>
										
						</div>
			
					</div>

				</div>
			</div>

		</React.Fragment>
	);
}
